var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullScreenClose(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28033 0.21967C0.987437 -0.0732231 0.512563 -0.0732231 0.21967 0.21967C-0.0732232 0.512563 -0.0732232 0.987437 0.21967 1.28033L3.43934 4.5H0.75C0.335786 4.5 0 4.83579 0 5.25C0 5.66421 0.335786 6 0.75 6H6V0.75C6 0.335787 5.66421 0 5.25 0C4.83579 0 4.5 0.335787 4.5 0.75V3.43934L1.28033 0.21967Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.5607L14.7197 15.7803C15.0126 16.0732 15.4874 16.0732 15.7803 15.7803C16.0732 15.4874 16.0732 15.0126 15.7803 14.7197L12.5607 11.5H15.25C15.6642 11.5 16 11.1642 16 10.75C16 10.3358 15.6642 10 15.25 10H10V15.25C10 15.6642 10.3358 16 10.75 16C11.1642 16 11.5 15.6642 11.5 15.25V12.5607Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7803 0.21967C16.0732 0.512563 16.0732 0.987437 15.7803 1.28033L12.5607 4.5H15.25C15.6642 4.5 16 4.83579 16 5.25C16 5.66421 15.6642 6 15.25 6H10V0.75C10 0.335786 10.3358 0 10.75 0C11.1642 0 11.5 0.335786 11.5 0.75V3.43934L14.7197 0.21967C15.0126 -0.0732231 15.4874 -0.0732231 15.7803 0.21967Z",
    fill: "#676879"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.21967 14.7197C-0.0732232 15.0126 -0.0732232 15.4874 0.21967 15.7803C0.512563 16.0732 0.987437 16.0732 1.28033 15.7803L4.5 12.5607L4.5 15.25C4.5 15.6642 4.83579 16 5.25 16C5.66421 16 6 15.6642 6 15.25L6 10L0.750001 10C0.335787 10 0 10.3358 0 10.75C0 11.1642 0.335787 11.5 0.750001 11.5H3.43934L0.21967 14.7197Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenClose);
export default __webpack_public_path__ + "static/media/full-screen-close.510651da.svg";
export { ForwardRef as ReactComponent };